export default {
  header: {
    homeLink: 'Home',
    aboutUsLink: 'Über Uns',
    servicesLink: 'Dienstleistungen',
    ourProjectsLink: 'Unsere Projekte',
    contact: 'Kontakt',
  },
  heroSection: {
    companyDescription: 'Wir erstellen individuelle Websites jeder Komplexität',
    contactUs: 'Kontaktieren Sie uns',
  },
};
